<div class="info-message">
  {{ message }}
  <ng-content></ng-content>
</div>
